import { render, staticRenderFns } from "./CadastroDicionarioDados.vue?vue&type=template&id=65b7ab40"
import script from "./CadastroDicionarioDados.vue?vue&type=script&lang=js"
export * from "./CadastroDicionarioDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports